import angular from 'angular';

import CategoryColorChartComponent from './category-color-chart.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-dashboard.component.category-color-chart', [])
    .component(CategoryColorChartComponent.selector, CategoryColorChartComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/category-color-chart/index.js